import { csContext } from "../cs-context";
import cmsContentMap from "./cms-content-map";

// eslint-disable-next-line import/prefer-default-export
export class CmsVariableProvider {
  replaceText(uid: string, lang: string, overrides: Record<string, string> = {}): string {
    switch (uid) {
      case cmsContentMap.variableNames.userFirstName:
        return overrides[cmsContentMap.variableNames.userFirstName] ?? csContext.user.firstName;
      case cmsContentMap.variableNames.userCurrentStrengthItemName:
        return (
          overrides[cmsContentMap.variableNames.userCurrentStrengthItemName] ??
          csContext.userProfile?.developProgress?.currentStrengthProgress?.strengthItemDisplayTitle
        );
      case cmsContentMap.variableNames.teamName:
        return (
          overrides[cmsContentMap.variableNames.teamName] ??
          csContext.currentTeam?.name ??
          "UNKNOWN_TEAM"
        );
      default:
        throw new Error(`Unexpected variable uid in content: ${uid}`);
    }
  }
}
